import "core-js/modules/es.array.push.js";
import url from 'url';
import queryString from 'querystring';
import axios from 'axios';
import { getone, parseTime, straightpay } from '../api/spzl';
import { NavBar, showToast } from 'vant';
import { mapGetters } from 'vuex';
import 'vant/es/toast/style';
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      viewhight: window.innerHeight - 2
    };
  },
  mounted() {
    //window.location.hash = encodeURIComponent('id=123');
    var uu = url.parse(document.URL);
    // let cs=uu.hash.substring(1);
    console.log(uu);
    // const params=new URLSearchParams(cs);
    // const res=params.get("name");
    // this.uusj=queryString.parse(cs);
    //const querystr=window.location.search;
    //const params=new URLSearchParams(querystr);
    this.$nextTick(() => {
      // DOM更新完成后的代码
      console.log('DOM更新完成');
    });
  },
  components: {
    [NavBar.name]: NavBar
  },
  computed: {
    ...mapGetters(['getseller'])
  },
  methods: {
    tofee() {
      this.$router.push('/cart');
    },
    toprovince() {
      this.$router.push('/user');
    },
    topublic() {
      this.$router.push('/goods');
    }
  }
};